import { Images } from 'assets/images';
import { ROUTES } from 'utils/routeNames';
import { useNavigate } from 'react-router-dom';
import {
  ProfileMainInfo,
  ProfileModalWrapper,
  ProfilePicture,
  ProfileUserInfo,
  ProfileUserName,
  ProfileUserEmail,
  ProfileSections,
  ProfileSection,
} from 'admin/components/ProfileModals/styled';

export const ProfileOpeningModal = () => {
  const navigate = useNavigate();

  const logOutFromAccount = () => {
    setTimeout(() => {
      navigate(`${ROUTES.ADMIN_SIGN_IN}`);
    }, 1000);
  };

  return (
    <ProfileModalWrapper>
      <ProfileMainInfo>
        <ProfilePicture src={Images.userDefaultImage} />
        <ProfileUserInfo>
          <ProfileUserName>Name Surname</ProfileUserName>
          <ProfileUserEmail>example@gmail.com</ProfileUserEmail>
        </ProfileUserInfo>
      </ProfileMainInfo>

      <ProfileSections>
        <ProfileSection onClick={() => navigate(`/${ROUTES.ADMIN_PROFILE}`)}>
          Profile
        </ProfileSection>
        <ProfileSection onClick={logOutFromAccount}>Log Out</ProfileSection>
      </ProfileSections>
    </ProfileModalWrapper>
  );
};
